module.exports = __webpack_public_path__ + "media/images/desenvolvimento2-678f11697fbf26193f624ef5837a1a91.jpg";